import {
  TREATMENT_INSTANCES_GET_REQUEST,
  TREATMENT_INSTANCES_GET_SUCCESS,
  TREATMENT_INSTANCES_GET_FAILURE,
  TREATMENT_INSTANCES_BY_ASSIGNMENT_GET_REQUEST,
  TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_SUCCESS,
  TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import {
  selectSelectedDate,
  selectSelectedTeam,
  selectSchedulerIsNightMode,
} from '../../../reducers/areas/dailyPlanning';
import { queryStringBuilder } from '../../../utils/helpers';

function setTreatmentInstances(response) {
  return {
    type: TREATMENT_INSTANCES_GET_SUCCESS,
    response,
  };
}

function setTreatmentInstancesLoading(silent) {
  return {
    type: TREATMENT_INSTANCES_GET_REQUEST,
    silent,
  };
}

function getTreatmentInstances(forceUpdate, silent = false) {
  return {
    types: [TREATMENT_INSTANCES_GET_REQUEST, TREATMENT_INSTANCES_GET_SUCCESS, TREATMENT_INSTANCES_GET_FAILURE],
    shouldCallAPI: forceUpdate ? () => true : state => state.dailyPlanning.treatments.items <= 0,
    buildCallParameters: state => {
      const parameters = {
        date: selectSelectedDate(state),
        teamIds: selectSelectedTeam(state),
        isNightMode: selectSchedulerIsNightMode(state),
        IsSchedulerDayNightMode: true,
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetTreatmentInstances${queryStringBuilder(parameters)}`,
      };
    },
    silent,
  };
}

function getTreatmentInstanceByAssignmentId(assignmentId, teamId) {
  return {
    types: [
      TREATMENT_INSTANCES_BY_ASSIGNMENT_GET_REQUEST,
      TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_SUCCESS,
      TREATMENT_INSTANCES_BY_ASSIGNMEN_GET_FAILURE,
    ],
    shouldCallAPI: () => true,
    buildCallParameters: () => {
      const parameters = {
        assignmentId,
        teamId,
      };
      return {
        method: HTTP_METHOD.GET,
        path: `v1/query/GetTreatmentInstanceByAssignmentId${queryStringBuilder(parameters)}`,
      };
    },
  };
}

export {
  getTreatmentInstances,
  setTreatmentInstances,
  setTreatmentInstancesLoading,
  getTreatmentInstanceByAssignmentId,
};
